import { Box, Button, DialogProps, Stack, Typography } from "@mui/material";
import InfoOutlineIcon from "@mui/icons-material/InfoOutlined";

import { BaseModal } from "../../Modal/BaseModal";
import LoadingButton from "../../Button/LoadingButton";

type ConfirmSetPasswordModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  maxWidth?: DialogProps["maxWidth"];
};

const ConfirmSetPasswordModal = ({
  open,
  onClose,
  onConfirm,
  maxWidth,
  isLoading,
}: ConfirmSetPasswordModalProps) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      title={
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InfoOutlineIcon color="primary" sx={{ fontSize: 28 }} />
          <Typography>パスワード設定</Typography>
        </Box>
      }
      children={
        <>
          <Typography
            sx={{ whiteSpace: "pre-line" }}
          >{`パスワードを変更します。 
          よろしいですか？`}</Typography>
        </>
      }
      actions={
        <Stack direction={"row"} spacing={2}>
          <Button
            disabled={isLoading}
            variant="outlined"
            onClick={onClose}
            autoFocus
          >
            キャンセル
          </Button>
          <LoadingButton
            isLoading={isLoading}
            variant="contained"
            onClick={onConfirm}
            sx={{ minWidth: "120px" }}
          >
            変更
          </LoadingButton>
        </Stack>
      }
    />
  );
};

export default ConfirmSetPasswordModal;
